import { Select, type SelectProps } from '@aigc/antd';
import { useQuery } from '@tanstack/react-query';
import { http } from '../../common/http-client';

export const HeygenTargetLanguageSelect = ({
  ref,
  ...props
}: SelectProps<string>) => {
  const { data, isPending } = useQuery({
    queryKey: ['target-languages'],
    queryFn: () => {
      return http
        .get<Array<{ label: string; value: string }>>(
          'video/translation/languages/heygen',
        )
        .json();
    },
  });

  return (
    <Select
      ref={ref}
      {...props}
      showSearch={{ optionFilterProp: 'label' }}
      loading={isPending}
      options={data}
    ></Select>
  );
};
